/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * different kinds, how to assess and grade a submission to a task
 */
export type SubmissionState = (typeof SubmissionState)[keyof typeof SubmissionState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubmissionState = {
  not_started: 'not_started',
  draft: 'draft',
  marked_as_done: 'marked_as_done',
  submitted: 'submitted',
  rejected: 'rejected',
  graded: 'graded',
} as const;
